// removed by extract-text-webpack-plugin
module.exports = {"attendance-scan-modal-content":"attendance-scan-modal-content","scan-image":"scan-image","scan-note-red":"scan-note-red","circle-container":"circle-container","circle1":"circle1","blink-animation":"blink-animation","circle2":"circle2","circle3":"circle3","circle4":"circle4","circle5":"circle5","pulse":"pulse","noShowCheck":"noShowCheck","showCheck":"showCheck"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/AttendanceScan/Modal.scss
// module id = cN55
// module chunks = 0